export const getUserOrCompanyName = (users, company, showOrgAvatar) => {
  if (!company) return null;

  if (showOrgAvatar || !users || users.size === 0) return company.name;

  return users.last().name;
};
